import React, { useCallback, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PosterSession from "./PosterSession";
import Configuration from "./Configuration";

import fetch from "node-fetch";
import "./App.css";
import "react-awesome-lightbox/build/style.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NewApplication from "./new-application";
import { API_URL, CONF, SESSIONS } from "./config";
import AllSessions from "./AllSessions";
import Presentation from "./presentation";
import { LanguageContext } from "./i18n/context";
function App() {
  const [postersConfig, setPostersConfig] = useState({});
  const [language, setLanguage] = useState("PL");

  const changeLanguage = useCallback(() => {
    setLanguage((lang) => (lang === "PL" ? "EN" : "PL"));
  }, []);

  useEffect(() => {
    const fetchContentConfig = async () => {
      const response = await fetch(`${API_URL}/content?conf=${CONF}`);
      if (response.status < 300) {
        const json = await response.json();
        const sessionsArray = SESSIONS.split(",");
        const keysToRemove = Object.keys(json.themes).filter(
          (x) => !sessionsArray.includes(x)
        );

        keysToRemove.forEach((k) => delete json.themes[k]);

        setPostersConfig(json);
      } else {
        console.warn(
          "Brak zdefiniowanej konfiguracji dla sesji plakatowej. Skontatkuj się z administratorem."
        );
      }
    };

    fetchContentConfig();
  }, []);

  return (
    <LanguageContext.Provider
      value={{
        language,
        changeLanguage,
      }}
    >
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="new-application" element={<NewApplication />}></Route>

            <Route
              exact
              path="allSessions"
              element={<AllSessions config={postersConfig} />}
            ></Route>
            <Route
              exact
              path="presentation"
              element={<Presentation config={postersConfig} />}
            ></Route>
            <Route
              exact
              path="sessions/:sessionId/posters/:posterId"
              element={<PosterSession config={postersConfig} />}
            ></Route>
            <Route
              exact
              path="sessions/:sessionId"
              element={<PosterSession config={postersConfig} />}
            ></Route>
            <Route path="config" element={<Configuration />}></Route>
            <Route
              path="/"
              element={
                <div className="sessions-list">
                  <div className="sessions">
                    <AllSessions config={postersConfig} />
                  </div>
                </div>
              }
            ></Route>
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
